import React from 'react';
import '../../styles/Instrucciones.css';

//Imagenes
import logo from '../../imgs/otros/juego rio-15.png';
import instrucciones1 from '../../imgs/instruccionesFormulario/instrucciones-1.jpg';
import instrucciones2 from '../../imgs/instruccionesFormulario/instrucciones-2.jpg';
import instrucciones3 from '../../imgs/instruccionesFormulario/instrucciones-3.jpg';
import instrucciones4 from '../../imgs/instruccionesFormulario/instrucciones-4.jpg';
import instrucciones5 from '../../imgs/instruccionesFormulario/instrucciones-5.jpg';
import instrucciones6 from '../../imgs/instruccionesFormulario/instrucciones-6.jpg';
import instrucciones7 from '../../imgs/instruccionesFormulario/instrucciones-7.jpg';


export default function FormularioInstrucciones(props) {
    return (
        <div className='Instrucciones__div--container Instrucciones__div--container-formulario' onClick={() => props.desactivarInstrucciones()}>
            <div className='Instrucciones__div--panel-instrucciones'>
                <div className='Instrucciones__div--cerrar'></div>
                <div className='Instrucciones__div--container-imagen'>
                    <img className='Instrucciones__img--logo' src={logo} alt='logo.png'/>
                </div>
                <h2 className='Instrucciones__h2--instrucciones'>
                    Primeros pasos
                </h2>
                <div className='Instrucciones__div--seccion'>
                    <h3>
                        Vincularte a una sesión
                    </h3>
                    <p>
                        Antes de entrar al juego debes tener una sesión a la que vincularte, si no la tienes pídeselo al guía encargado de la actividad.

                        Vas a desplegar las opciones en “elegir sesión” posteriormente vas a elegir la sesión a la que debes vincularte, además vas a elegir la cantidad de jugadores de la partida, de 1 a 4.<br></br><br></br>

                        <b>Importante!!!</b>
                        <br></br><br></br>

                        Siempre se jugará con los 4 fichos, en caso de ser 3 o menos jugadores se repartirán los fichos y podrán elegir en la siguiente pantalla quien juega con determinados fichos, en caso de estar solo jugaras con los 4 fichos.
                    </p>
                    <br></br>
                    <div className='Instrucciones__div--container-dados-notificaciones'>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img  Instrucciones__img--notificaciones' src={instrucciones1} alt='instrucciones1.jpg'/>
                        </div>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img Instrucciones__img--dados' src={instrucciones2} alt='instrucciones2.jpg'/>
                        </div>
                    </div>
                    <br></br>
                    <br></br>
                    <br></br>
                    <h3>
                        Registro jugadores
                    </h3>
                    <p>
                        En la pantalla aparecerá el o los campos de los jugadores elegidos previamente, en cada campo se mostraran los fichos con los que jugara, si previamente se eligieron 3 jugadores, uno jugara con dos fichos.

                        Importante!!!

                        Si ya jugaste en la sesión asignada procura poner de nuevo el correo con el que jugaste la primera vez para no generar más de un registro de tu actividad en el juego.
                    </p>
                    <br></br>
                    <p>
                        Pasa con el mouse por encima para acercar la imagen
                    </p>
                    <div className='Instrucciones__div--container-dados-notificaciones'>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img  Instrucciones__img--3' src={instrucciones3} alt='instrucciones3.jpg'/>
                        </div>
                    </div>
                    <br></br>
                    <div className='Instrucciones__div--container-dados-notificaciones'>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img Instrucciones__img--4' src={instrucciones4} alt='instrucciones4.jpg'/>
                        </div>
                    </div>
                    <br></br>
                    <div className='Instrucciones__div--container-dados-notificaciones'>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img Instrucciones__img--5' src={instrucciones5} alt='instrucciones5.jpg'/>
                        </div>
                    </div>
                    <br></br>
                    <div className='Instrucciones__div--container-dados-notificaciones'>
                        <div className='Instrucciones__div--container-imagen'>
                            <img className='Instrucciones__img Instrucciones__img--6' src={instrucciones6} alt='instrucciones6.jpg'/>
                        </div>
                    </div>
                    <br></br>
                    <br></br>
                    <br></br>
                    <h3>
                        Verificar datos
                    </h3>
                    <p>
                        Al continuar antes de iniciar la partida encontraras los datos de la partida, verifica que toda la información sea correcta, en caso de serlo continua y comienza la partida, en caso de no serlo recarga la página y haz el proceso nuevamente.
                    </p>
                    <div className='Instrucciones__div--container-imagen'>
                        <img className='Instrucciones__img Instrucciones__img--7' src={instrucciones7} alt='instrucciones7.jpg'/>
                    </div>
                </div>
            </div>
        </div>
    )
}
